<template>
    <div class>
      <div class="ba_f outmain">
        <div class="shuju_title">
          <div class="shuju_title_text">
            <span>筛选条件</span>
          </div>
        </div>
        <el-form :inline="false" :model="form" class="demo-form-inline" label-width="100px">
          <div class="flex ba_f">
            <el-form-item label="查询日期：" class="mar_t20">
              <div class="flex-bet">
                <div>
                  <el-radio-group v-model="form.timeType" @change="selectType">
                    <el-radio-button label="1">今天</el-radio-button>
                    <el-radio-button label="2">近七天</el-radio-button>
                    <el-radio-button label="3">近十五天</el-radio-button>
                    <el-radio-button label="4">自定义时间</el-radio-button>
       
                  </el-radio-group>
                  <span class="mar_l20" v-if="form.timeType=='4'">
                  <el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期"
                                  end-placeholder="结束日期" format="yyyy年MM月dd日" :picker-options="pickerOptions" @change="selectType"></el-date-picker>
                </span>
     
                </div>
              </div>
            </el-form-item>
          </div>

        </el-form>
      </div>


      <!--  -->

      <div class="mar_t20 ba_f outmain">
        <div class="shuju_title">
          <div class="shuju_title_text">
            <span>整体看板</span>
          </div>
          <!--    <div class="fon_12 ab r0 mar_r10 color_9">更新时间：2020-09-04 13:32:59</div>-->
        </div>
        <div class="main-icon flex t_l mar_t20">
    
          <div class="flex-1 t_l pad_20 borderBG mar_r20">
            <div class="flex-bet flex-y-top">
              <div>
                <p class="title6 fon_14">企业数量</p>
                <p class="fon_30 title35 lh16 pad_tb_20 wei">{{ user.company_count || 0 }}</p>
                <!-- <p class="fon_12 title6 lh25">服务费支出：{{ jeData.commission || 0 }}</p> -->
              </div>
            </div>
          </div>
          <div class="flex-1 t_l pad_20 borderBG mar_r20">
            <div class="flex-bet flex-y-top">
              <div>
                <p class="title6 fon_14">用户数量</p>
                <p class="fon_30 title35 lh16 pad_tb_20 wei">{{ user.user_count || 0 }}</p>
                <!-- <p class="fon_12 title6 lh25">服务费支出：{{ jeData.commission || 0 }}</p> -->
              </div>
            </div>
          </div>
  
        </div>
        <div id="zhentiEch" style="height: 360px;" class="mar_t20"></div>
      </div>


      <div class="mar_t20 ba_f outmain pad_20">
  <div class="shuju_title">
    <div class="shuju_title_text">
      <span>用户行为分析</span>
    </div>
  </div>
  <div class="flex-bet chart-container">
    <!-- 主图表区 -->
    <div class="bflex-7 chart-main">
      <div  id="zhentiEch3" style="height:360px"></div>
      <!-- <div v-else class="empty-chart">暂无趋势数据</div> -->
    </div>
    
    <!-- 右侧统计面板 -->
    <div class="bflex-3 stat-panel">
      <!-- 指标卡片 -->

      <div class="stat-card-group">
        <div class="stat-card">
          <div class="stat-label">
            <i class="el-icon-data-analysis"></i>
            用户数量
          </div>
          <div class="stat-value">{{ jeData.user_count | 0 }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">
            <i class="el-icon-c-scale-to-original"></i>
            用户收藏
          </div>
          <div class="stat-value">{{ jeData.collect_count | 0 }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">
            <i class="el-icon-c-scale-to-original"></i>
            用户点赞
          </div>
          <div class="stat-value">{{ jeData.like_count | 0 }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">
            <i class="el-icon-c-scale-to-original"></i>
            用户点击
          </div>
          <div class="stat-value">{{ jeData.click_count | 0 }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">
            <i class="el-icon-c-scale-to-original"></i>
            使用时长
          </div>
          <div class="stat-value">{{ jeData.duration | 0 }}</div>
        </div>
      </div>

      <!-- 热门话题 -->
      <div class="hot-topics">
        <h3 class="hot-title">
          <i class="el-icon-star-off"></i>
          用户排行榜 TOP10
        </h3>
        <div v-if="topics.length" class="topic-list">
          <div v-for="(item,index) in topics" 
               :key="item.name" 
               class="topic-item"
               @mouseover="highlightTopic(item.name)">
            <div class="topic-rank">
              <span :class="['rank-badge', {top3: index < 3}]">
                {{ index+1 }}
              </span>
            </div>
            <div class="topic-info">
              <div class="topic-name text-ellipsis">{{ item.nickName || '未知用户' }}</div>
              <div class="topic-stats">
                <span class="usage-count">收藏：{{ item.stats.collect || 0 }}次</span>
                <span class="usage-count">点赞：{{ item.stats.like || 0 }}次</span>
                <span class="usage-count">点击：{{ item.stats.click || 0 }}次</span>
                <span class="usage-count">时长：{{ item.stats.duration || "" }}</span>
                <span class="sort-order">优先级：{{ item.sort }}</span>
              </div>

            </div>
          </div>
        </div>
        <div v-else class="empty-tips">暂无用户排行数据</div>
      </div>
    </div>
  </div>
</div>

<div class="mar_t20 ba_f outmain" style="height: 520px;">
       <div class="shuju_title">
         <div class="shuju_title_text">
           <span>用户数据</span>
         </div>
       </div>
       <div class="mar_t20 flex-bet">
         
        <div class="flex-g-1 mar_l20" style="height: 420px;width: 300px;margin-top: -220px;">
           <div class="flex t_l">
             <div class="title35">用户</div>

           </div>
           <div class="mar_t10 shuju_table" v-if="user.user && user.user.data">
             <el-table :data="user.user.data" stripe style="width: 100%">
               <el-table-column prop="nickName" label="昵称"></el-table-column>
               <el-table-column prop="mobile" label="联系方式"></el-table-column>
               <el-table-column prop="mobile" label="收藏"></el-table-column>
               <el-table-column prop="mobile" label="点赞"></el-table-column>
               <el-table-column prop="mobile" label="点击"></el-table-column>
               <el-table-column prop="mobile" label="使用时长"></el-table-column>

               <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="chooseClick(scope.row)" type="text" size="small">选择</el-button>
             
              </template>
            </el-table-column>
             </el-table>
           </div>
         </div>
        
        <div class="flex-g-1" style="height: 667px;margin-left: 10px;width: 400px;">
          <!-- <iframe :src="h5Url" width="375px" height="667px" frameborder="0" style="border: 1px dashed #eee;"></iframe> -->
          <div id="zhentiEch4" style="height: 360px;" class="mar_t20"></div>
         </div>
       
       </div>  </div>



       <div v-if="selectedUserData" class="stat-card-group">
    <div class="stat-card highlight">
      <div class="stat-label">
        <i class="el-icon-user"></i>
        用户画像
      </div>
      <div class="profile-name">{{ selectedUserData.nickName || '未知用户' }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-label">
        <i class="el-icon-collection"></i>
        收藏总量
      </div>
      <div class="stat-value">{{ selectedUserData.stats.collect || 0 }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-label">
        <i class="el-icon-thumb"></i>
        点赞总量
      </div>
      <div class="stat-value">{{ selectedUserData.stats.like || 0 }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-label">
        <i class="el-icon-mouse"></i>
        点击总量
      </div>
      <div class="stat-value">{{ selectedUserData.stats.click || 0 }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-label">
        <i class="el-icon-timer"></i>
        使用时长
      </div>
      <div class="stat-value">{{ formatDuration(selectedUserData.stats.duration) }}</div>
    </div>
  </div>

  <!-- 新增用户行为趋势图 -->
  <div v-if="selectedUserData" class="chart-container">
    <h3 class="chart-title">行为趋势分析</h3>
    <div id="zhenEch" style="height: 360px;" class="mar_t20"></div>
  </div>



     <div class="mar_t20 pad_20 ba_f outmain">
       <div class="shuju_title">
         <div class="shuju_title_text">
           <span>企业数据</span>
         </div>
       </div>
       <div class="mar_t20 flex-bet">
         <div class="flex-g-1" style="height: 520px;">
           <div class="flex t_l">
             <div class="title35">企业</div>
           </div>
           <div class="mar_t10 shuju_table" v-if="user.company && user.company.data">
             <el-table :data="user.company.data" stripe style="width: 100%">
            
               <el-table-column prop="create_time" label="认证时间"></el-table-column>>
               <el-table-column prop="create_time" label="企业创立时间"></el-table-column>
               <el-table-column prop="nickName" label="企业名称"></el-table-column>>
               <el-table-column prop="attr" label="行业属性"></el-table-column>
             </el-table>
           </div>
         </div>
    
       </div>  </div>

    </div>
  </template>
  <script>
  import echarts from 'echarts';
  import StatisticsApi from '@/api/statistics.js';
  import NotesApi from '@/api/notes.js';
  import { changeDate } from '@/utils/index';
  export default {
    mounted() {
      window.addEventListener('resize', this.initchart);

    },
    
    data() {
      return {
        selectData: '',
        pickerOptions: {
          disabledDate: (time) => {
            // 计算允许的最小日期（当前月前推6个月的第一天）
            const minDate = new Date()
            minDate.setMonth(minDate.getMonth() - 6)
            minDate.setDate(1)
            minDate.setHours(0, 0, 0, 0)

            // 计算允许的最大日期（当前月最后一天）
            const maxDate = new Date()
            maxDate.setMonth(maxDate.getMonth() + 1, 0)
            maxDate.setHours(23, 59, 59, 999)

            // 禁用不在时间范围内的日期
            return time < minDate || time > maxDate
          }
        },
        dddata: {},
        zhData: {},
        jeData: {},
        jyData: {},
        form: {
          shopValue: '',
          timeType: '3',
          time: [new Date(), new Date()],
          Mtime: '',
        
        },



        echarts2_option: {
          color: ['#FF6B6B', '#4ECDC4', '#edff68'], // 调整为三色系
          tooltip: {
            trigger: 'axis',
            formatter: function(params) {
              let tip = params[0].name + '<br/>';
              params.forEach(item => {
                tip += `${item.marker} ${item.seriesName}: ${item.value}<br/>`;
              });
              return tip;
            }
          },
          legend: {
            data: ['企业数', '用户数'] // 对应接口返回的字段
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#333',
              fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: '#f7f7f7',
                width: 2
              }
            },
            data: [] // 绑定月份数据
          },
          yAxis: {
            type: 'value',
            axisTick: { show: false },
            axisLine: { show: false },
            axisLabel: {
              color: '#333',
              fontSize: 12
            },
            splitLine: {
              lineStyle: {
                type: 'dotted',
                color: '#DDDDDD'
              }
            }
          },
          series: [
            {
              name: '企业数',
              type: 'line',
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(255,107,107,0.6)' },
                  { offset: 1, color: 'rgba(255,107,107,0.05)' }
                ])
              },
              data: []
            },
            {
              name: '用户数',
              type: 'line',
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(78,205,196,0.6)' },
                  { offset: 1, color: 'rgba(78,205,196,0.05)' }
                ])
              },
              data: []
            },
        
          ]
        },
        echarts3Option: {
        color: ['#1890FF', '#2FC25B', '#9254ff', '#3af4e5', '#ff4800'],
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let tip = `<strong>${params[0].name}</strong><br>`
            params.forEach(item => {
              tip += `${item.marker} ${item.seriesName}: ${item.value.toLocaleString()}<br>`
            })
            return tip
          }
        },
        legend: {
          data: ['用户数量', '用户收藏', '用户点赞', '用户点击', '使用时长'],
          bottom: 10
        },
        grid: {
          left: 60,
          right: 40,
          top: 40,
          bottom: 40,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            rotate: 45
          },
          data: []
        },
        yAxis: [
          {
            type: 'value',
            name: '用户数量',
            axisLine: { show: false },
            splitLine: { lineStyle: { type: 'dashed' } }
          },
          {
            type: 'value',
            name: '用户收藏',
            axisLine: { show: false },
            splitLine: { lineStyle: { type: 'dashed' } }
          },
          {
            type: 'value',
            name: '用户点赞',
            axisLine: { show: false },
            splitLine: { lineStyle: { type: 'dashed' } }
          },
          {
            type: 'value',
            name: '用户点击',
            axisLine: { show: false },
            splitLine: { lineStyle: { type: 'dashed' } }
          },
          {
            type: 'value',
            name: '使用时长',
            axisLine: { show: false },
            splitLine: { lineStyle: { type: 'dashed' } }
          }
        ],
        series: [

        {
            name: '用户数量',
            type: 'line',
   
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderRadius: [4, 4, 0, 0]
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(59, 159, 247,0.6)' },
                { offset: 1, color: 'rgba(59, 159, 247,0.05)' }
                ])
              }, 
            data: []
          },
   
          {
            name: '用户收藏',
            type: 'line',
            yAxisIndex: 1,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderRadius: [4, 4, 0, 0]
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(47, 194, 91,0.6)' },
                  { offset: 1, color: 'rgba(47, 194, 91,0.05)' }
                ])
              }, 
            data: []
          },
          {
            name: '用户点赞',
            type: 'line',
            yAxisIndex: 2,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderRadius: [4, 4, 0, 0]
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(146, 84, 255,0.6)' },
                  { offset: 1, color: 'rgba(146, 84, 255,0.05)' }
                ])
              }, // '#3bf747', '#ff4800'
            data: []
          },
          {
            name: '用户点击',
            type: 'line',
            yAxisIndex: 3,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderRadius: [4, 4, 0, 0]
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(58, 244, 229,0.6)' },
                  { offset: 1, color: 'rgba(58, 244, 229,0.05)' }
                ])
              }, // '#3bf747', '#ff4800'
            data: []
          },
          {
            name: '使用时长',
            type: 'line',
            yAxisIndex: 4,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderRadius: [4, 4, 0, 0]
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(255, 72, 0,0.6)' },
                  { offset: 1, color: 'rgba(255, 72, 0,0.05)' }
                ])
              }, // '#3bf747', '#ff4800'
            data: []
          }
        ]
      },


    
        notesRecord:{},
        jeData:{},
        topics:[],
          h5Url: '',
          user:{},





          selectedUser: null,
      selectedUserData: null,
      userChartOptions: null,
      

      user_id:0,

      echarts4Option: {
        color: ['#1890FF', '#2FC25B', '#9254ff', '#3af4e5', '#ff4800'],
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let tip = `<strong>${params[0].name}</strong><br>`
            params.forEach(item => {
              tip += `${item.marker} ${item.seriesName}: ${item.value.toLocaleString()}<br>`
            })
            return tip
          }
        },
        legend: {
          data: ['用户数量', '用户收藏', '用户点赞', '用户点击', '使用时长'],
          bottom: 10
        },
        grid: {
          left: 60,
          right: 40,
          top: 40,
          bottom: 40,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            rotate: 45
          },
          data: []
        },
        yAxis: [
          {
            type: 'value',
            name: '用户数量',
            axisLine: { show: false },
            splitLine: { lineStyle: { type: 'dashed' } }
          },
          {
            type: 'value',
            name: '用户收藏',
            axisLine: { show: false },
            splitLine: { lineStyle: { type: 'dashed' } }
          },
          {
            type: 'value',
            name: '用户点赞',
            axisLine: { show: false },
            splitLine: { lineStyle: { type: 'dashed' } }
          },
          {
            type: 'value',
            name: '用户点击',
            axisLine: { show: false },
            splitLine: { lineStyle: { type: 'dashed' } }
          },
          {
            type: 'value',
            name: '使用时长',
            axisLine: { show: false },
            splitLine: { lineStyle: { type: 'dashed' } }
          }
        ],
        series: [

        {
            name: '用户数量',
            type: 'line',
   
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderRadius: [4, 4, 0, 0]
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(59, 159, 247,0.6)' },
                { offset: 1, color: 'rgba(59, 159, 247,0.05)' }
                ])
              }, 
            data: []
          },
   
          {
            name: '用户收藏',
            type: 'line',
            yAxisIndex: 1,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderRadius: [4, 4, 0, 0]
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(47, 194, 91,0.6)' },
                  { offset: 1, color: 'rgba(47, 194, 91,0.05)' }
                ])
              }, 
            data: []
          },
          {
            name: '用户点赞',
            type: 'line',
            yAxisIndex: 2,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderRadius: [4, 4, 0, 0]
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(146, 84, 255,0.6)' },
                  { offset: 1, color: 'rgba(146, 84, 255,0.05)' }
                ])
              }, // '#3bf747', '#ff4800'
            data: []
          },
          {
            name: '用户点击',
            type: 'line',
            yAxisIndex: 3,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderRadius: [4, 4, 0, 0]
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(58, 244, 229,0.6)' },
                  { offset: 1, color: 'rgba(58, 244, 229,0.05)' }
                ])
              }, // '#3bf747', '#ff4800'
            data: []
          },
          {
            name: '使用时长',
            type: 'line',
            yAxisIndex: 4,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderRadius: [4, 4, 0, 0]
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(255, 72, 0,0.6)' },
                  { offset: 1, color: 'rgba(255, 72, 0,0.05)' }
                ])
              }, // '#3bf747', '#ff4800'
            data: []
          }
        ]
      },

       
      };
    },
    computed: {
    
    },
    created() {
      // this.selectUser(1);


      setTimeout(() => {
        this.getUserRecord();
        this.getUserById()
      }, 500);
    
    },
    methods: {


    formatDuration(seconds) {
      if (!seconds) return '0分钟';
      const mins = Math.floor(seconds / 60);
      return `${mins} 分钟`;
    },



        selectUser(user_id) {
        // 根据用户 ID 动态生成 H5 页面 URL
          this.h5Url = `http://hxing.1.y01.cn/h5/#/plus2/pages/analysis/detail_u?user_id=${user_id}`;
        },
        chooseClick(row){
          this.user_id = row.user_id;
          this.getUserById();
        },
        selectType(){

          this.getUserRecord();
        },
        isNull(value) {
          if (value) {
            return false
          }
          return true
        },
        // 高亮关联数据点
        highlightTopic(topicName) {
          // 这里可添加图表高亮逻辑
        },
        getUserById(){
          var self = this;
          window.addEventListener('resize', this.initchart);
          self.loading = true;
          var Params = {
            user_id:self.user_id
          };
          NotesApi.getUserStatsById(Params, true)
            .then(data => {
              console.log('data',data)
              self.loading = false;
              self.echarts4Option.series[0].data = data.data.list.chart.series['用户数量'];
              self.echarts4Option.series[1].data = data.data.list.chart.series['用户收藏'];
              self.echarts4Option.series[2].data = data.data.list.chart.series['用户点赞'];
              self.echarts4Option.series[3].data = data.data.list.chart.series['用户点击'];
              self.echarts4Option.series[4].data = data.data.list.chart.series['使用时长'];
              self.echarts4Option.xAxis.data = data.data.list.chart.xAxis;
              self.zhentiEch4();

            })
        },
        getUserRecord(){
          var self = this;
          self.loading = true;
          let startTime = '';
          let endTime = '';
          if (this.form.time) {
            startTime = changeDate(this.form.time[0]);
            endTime = changeDate(this.form.time[1]);
          }


          let Params = {
         
            timeType:this.form.timeType,
            startTime,
            endTime,
          };
          NotesApi.getUsers(Params, true)
            .then(data => {
              self.loading = false;
              self.user = data.data.list.stats;
              self.echarts2_option.series[0].data = data.data.list.chart.series['企业数'];
              self.echarts2_option.series[1].data = data.data.list.chart.series['用户数'];

              self.echarts2_option.xAxis.data =data.data.list.chart.xAxis;
              self.zhentiEch();

            })

            NotesApi.getUserStats(Params, true)
            .then(data => {
              self.loading = false;
              self.jeData = data.data.list.stats
              self.topics =  data.data.list.users
              self.echarts3Option.series[0].data = data.data.list.chart.series['用户数量'];
              self.echarts3Option.series[1].data = data.data.list.chart.series['用户收藏'];
              self.echarts3Option.series[2].data = data.data.list.chart.series['用户点赞'];
              self.echarts3Option.series[3].data = data.data.list.chart.series['用户点击'];
              self.echarts3Option.series[4].data = data.data.list.chart.series['使用时长'];

              self.echarts3Option.xAxis.data =data.data.list.chart.xAxis;

              self.zhentiEch3();

            })
         
            
        },

  
  
 
      initchart() {

        let myChart2 = echarts.init(document.getElementById('zhentiEch'));
        let myChart3 = echarts.init(document.getElementById('zhentiEch3'));
        let myChart4 = echarts.init(document.getElementById('zhentiEch4'));

        myChart2.resize();
        myChart3.resize();
        myChart4.resize();
      },


      zhentiEch() {
        let myChart = echarts.init(document.getElementById('zhentiEch'));
        myChart.setOption(this.echarts2_option, true);
      },
      zhentiEch3() {
        let myChart = echarts.init(document.getElementById('zhentiEch3'));
        myChart.setOption(this.echarts3Option, true);
      },
      zhentiEch4() {
        let myChart = echarts.init(document.getElementById('zhentiEch4'));
        myChart.setOption(this.echarts4Option, true);
      },
 
    }
  };
  </script>
  <style lang="scss" scoped>
  .title6 {
    color: #666;
    font-size: 14px;
  }
  
  .title35 {
    color: #353535;
  }
  
  .tongji_icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
/* 新增样式 */
.chart-container {
  gap: 20px;
}

.stat-card {
  background: #f8fafc;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
}
.stat-label {
  color: #666;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #1890FF;
  margin-top: 8px;
}

.hot-title {
  color: #333;
  font-size: 16px;
  margin: 15px 0;
}

.topic-item {
  display: flex;
  align-items: center;
  padding: 12px;
  margin: 6px 0;
  background: #fff;
  border-radius: 6px;
  transition: all 0.3s;
}
.topic-item:hover {
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}

.rank-badge {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: #f0f2f5;
  border-radius: 50%;
  font-size: 13px;
}
.rank-badge.top3 {
  background: #1890FF;
  color: white;
}

.topic-info {
  flex: 1;
  margin-left: 12px;
}
.topic-name {
  max-width: 120px;
  font-weight: 500;
}
.usage-count {
  color: #111111;
  font-size: 13px;
}
.sort-order {
  color: #999;
  font-size: 12px;
  margin-left: 8px;
}

.empty-chart, .empty-tips {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}



// 新增样式
.user-selector {
  margin-bottom: 20px;
  max-width: 300px;
}

.profile-name {
  font-size: 18px;
  color: #409EFF;
  margin-top: 8px;
}

.highlight {
  border: 2px solid #409EFF;
  background: #f0faff;
  
  .stat-value {
    font-size: 24px;
  }
}

.chart-container {
  margin-top: 30px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}

.chart-title {
  color: #666;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 4px solid #409EFF;
}
  </style>
  


// WEBPACK FOOTER //
// src/views/statistics/new/user.vue